
import { mapState } from 'vuex'
import dealerDownload from '~/components/dealer/popup/dealerDownload.vue'

export default {
  name: 'RelationTree',
  components: {
    dealerDownload
  },
  props: {
    ispage: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {},
      required: true
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
    familytree: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myChart: null,
      treedata: this.familytree
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
      contentcookie: 'contentcookie',
      userVip: 'userVip',
      LanguageCode: 'LanguageCode',
      suffix: 'suffix',
      newhost: 'newhost',
      mobile: 'mobile'
    }),
    contentcookie1() {
      return this.contentcookie
    }
  },
  watch: {
    contentcookie1() {
      this.loginfn()
    },
    userVip(v) {
      console.log('v::: 这里', v)
    }
  },
  methods: {
    loginfn() {
      this.$api.common
        .CV3(
          {
            code: this.data?.code,
            type: 2,
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'wikifxagg$family_tree_entry_setting'
          }
        )
        .then((res) => {
          console.log(res?.wikifxagg?.family_tree_entry_setting?.data, 8889)
          this.treedata = res?.wikifxagg?.family_tree_entry_setting?.data || {}
        })
        .catch((err) => {
          console.log('wikifxagg$family_tree_entry_setting', err)
        })
    },
    showVipDialog() {
      if (this.matomoType) {
        this.matomofn('VIP_Join_Click', {
          type: this.matomoType,
          kind: this.userVip
        })
      }
      if (this.mobile) {
        this.todown()
      } else {
        const params = new URLSearchParams()
        params.set('matomotype', '企业族谱')
        const url = `https://www.${this.newhost}.${this.suffix}/${this.LanguageCode}/download.html?matomotype=${params.toString()}`
        return window.open(url)
      }
    },
    getOnlyShortName(sName, sName1) {
      if (!sName) {
        return sName1
      } else {
        return sName
      }
    },
    totreefn() {
      window.open(`/${this.$store.state.LanguageCode}/family/${this.data?.code}.html`)
    },
    todown() {
      const params = new URLSearchParams()
      params.set('matomotype', '企业族谱')
      const ua = navigator.userAgent.toLowerCase()
      const isAndroid = ua.includes('android') || ua.includes('linux')
      /** fxeyemaster海外版 fxeyechinesemaster中文版 */
      if (isAndroid) {
        const iframe = document.createElement('iframe')
        iframe.src = `wikifx://tans?languageCode=${this.$route?.params?.lang}&code=${this.$route?.params?.id?.split('.')?.[0]}&appjumptype=9999`
        iframe.style.display = 'none'
        document.body.appendChild(iframe)

        setTimeout(() => {
          const url = `https://www.${this.newhost}.${this.suffix}/${this.LanguageCode}/download.html?matomotype=${params.toString()}`
          window.open(url)
        }, 3000)
      } else {
        window.location = `wikifx://tans?languageCode=${this.$route?.params?.lang}&code=${this.$route?.params?.id?.split('.')?.[0]}&appjumptype=9999`
        setTimeout(() => {
          const url = `https://www.${this.newhost}.${this.suffix}/${this.LanguageCode}/download.html?matomotype=${params.toString()}`
          window.location = url
        }, 2000)
      }
    }
  }
}
